// Constants File Declaration
module.exports = Object.freeze({
    LOGIN: "login",
    API: "api",
    ORIG: "orig"
})